/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type BriefChatMutationVariables = Types.Exact<{
    id: Types.Scalars['String'];
    message: Types.Scalars['String'];
    expectedMessageCount: Types.Scalars['Int'];
}>;

export type BriefChatMutation = {
    __typename: 'Mutation';
    briefChat: {
        __typename: 'BriefChatResponse';
        component: Types.Maybe<string>;
        message: { __typename: 'BriefChatMessage'; role: string; content: string };
        document: Types.Maybe<{
            __typename: 'Document';
            id: string;
            schema: Types.Maybe<{
                __typename: 'BriefSchema';
                id: string;
                fields: Array<{
                    __typename: 'BriefFieldDefinition';
                    key: string;
                    label: string;
                    required: boolean;
                }>;
            }>;
            values: Array<{
                __typename: 'BriefFieldValue';
                key: string;
                text: Types.Maybe<string>;
                multiText: Types.Maybe<Array<string>>;
                integer: Types.Maybe<number>;
                date: Types.Maybe<any>;
                boolean: Types.Maybe<boolean>;
                choice: Types.Maybe<string>;
                multiChoice: Types.Maybe<Array<string>>;
                files: Types.Maybe<
                    Array<{
                        __typename: 'BriefFile';
                        bucket: string;
                        key: string;
                        name: string;
                        previewable: boolean;
                        size: number;
                    }>
                >;
            }>;
        }>;
    };
};

export const BriefChatDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'BriefChat' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'expectedMessageCount' },
                    },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'briefChat' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'id' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'message' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'message' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'expectedMessageCount' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'expectedMessageCount' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'content' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'component' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'document' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'schema' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fields' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'key',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'label',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'required',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'values' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'key' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'text' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'multiText',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'integer',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'date' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'boolean',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'choice' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'multiChoice',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'files' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'bucket',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'key',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'name',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'previewable',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'size',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type BriefChatMutationFn = Apollo.MutationFunction<
    BriefChatMutation,
    BriefChatMutationVariables
>;

/**
 * __useBriefChatMutation__
 *
 * To run a mutation, you first call `useBriefChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBriefChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [briefChatMutation, { data, loading, error }] = useBriefChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *      expectedMessageCount: // value for 'expectedMessageCount'
 *   },
 * });
 */
export function useBriefChatMutation(
    baseOptions?: Apollo.MutationHookOptions<BriefChatMutation, BriefChatMutationVariables>
) {
    return Apollo.useMutation<BriefChatMutation, BriefChatMutationVariables>(
        BriefChatDocument,
        baseOptions
    );
}
export type BriefChatMutationHookResult = ReturnType<typeof useBriefChatMutation>;
export type BriefChatMutationResult = Apollo.MutationResult<BriefChatMutation>;
export type BriefChatMutationOptions = Apollo.BaseMutationOptions<
    BriefChatMutation,
    BriefChatMutationVariables
>;
